{
  "(optional)": "(незадължително)",
  "(required)": "(задължително)"
}
